import { useWorkOrderRecord } from "@/app/ProDrivers/WorkOrders/Hooks/useWorkOrderRecord";
import { QuoteTable } from "@/app/Quotes/Components/QuoteTable";
import { InvoiceTable } from "@/app/Invoices/Components/InvoiceTable";
import {
  QueryInvoicesWhereWorkOrderColumn,
  QueryQuotesWhereWorkOrderColumn,
  SqlOperator,
} from "@/gql/graphql";
import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { CreateQuoteDialog } from "@/app/Quotes/Components/CreateQuoteDialog";
import { AssignInvoiceToWorkOrderDialog } from "@/app/ProDrivers/WorkOrders/Components/Dialogs/AssignInvoiceToWorkOrderDialog";
import { PlusIcon } from "@heroicons/react/20/solid";
import { LinkIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "use-intl";
import { getQuoteInitialFieldsFromWorkOrder } from "@/app/ProDrivers/WorkOrders/utils/getQuoteInitialFieldsFromWorkOrder";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { invoiceWorkOrderMutation } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrdersMutations";

export function WorkOrderBillingScreen() {
  const workOrder = useWorkOrderRecord();
  const { id, supplier } = workOrder;
  const t = useTranslations("workOrder");
  const tAssignInvoice = useTranslations("workOrder.dialogs.assignInvoice");
  const tInvoiceCard = useTranslations("workOrder.cards.invoice");
  const { open: openCreateQuote } = useDialog(CreateQuoteDialog);
  const { open: openAssignInvoice } = useDialog(AssignInvoiceToWorkOrderDialog);
  const { mutateAsync: invoiceWorkOrder, isPending } = useGqlMutation(
    invoiceWorkOrderMutation,
  );

  return (
    <div className="space-y-8 pt-6">
      <QuoteTable
        id="work-order-quote-table"
        title={t("tabs.quotes")}
        queryVariables={{
          whereWorkOrder: {
            column: QueryQuotesWhereWorkOrderColumn.Id,
            operator: SqlOperator.Eq,
            value: id,
          },
        }}
        buttons={
          <Button
            LeadingIcon={PlusIcon}
            onClick={() => {
              openCreateQuote({
                initialValues: getQuoteInitialFieldsFromWorkOrder(workOrder),
              });
            }}
          >
            Create Quote
          </Button>
        }
      />

      <InvoiceTable
        id="work-order-invoice-table"
        title={t("tabs.invoices")}
        queryVariables={{
          whereWorkOrder: {
            column: QueryInvoicesWhereWorkOrderColumn.Id,
            operator: SqlOperator.Eq,
            value: id,
          },
        }}
        buttons={
          <div className="flex gap-2">
            <Button
              outline
              onClick={() => invoiceWorkOrder({ id })}
              disabled={isPending}
            >
              <PlusIcon />
              {isPending
                ? tInvoiceCard("creating")
                : tInvoiceCard("createInvoice")}
            </Button>
            <Button
              outline
              onClick={() =>
                openAssignInvoice({
                  workOrderId: id,
                  supplierId: supplier?.id,
                })
              }
            >
              <LinkIcon />
              {tAssignInvoice("title")}
            </Button>
          </div>
        }
      />
    </div>
  );
}
